import React from 'react'
import { useLocation } from '@reach/router'
import BlogCard from '../components/blogCard'
import Layout from '../components/layout'

const TagsPage = ({
  data: {
    site,
    allMarkdownRemark: { edges },
  },
}) => {
  const location = useLocation()
  // Get the tag name
  const tag = location.pathname.split('/')[2]
  // Filter posts by tag
  const tagPost = edges
    .filter(
      (edge) =>
        !!edge.node.frontmatter.date &&
        edge.node.frontmatter.tags &&
        edge.node.frontmatter.tags.includes(tag)
    ) // You can filter your posts based on some criteria
    .map((edge) => <BlogCard key={edge.node.id} post={edge.node} />)
  return (
    <Layout>
      <h2 className="font-bold text-2xl">{tag} &darr;</h2>
      <div className="grids">{tagPost}</div>
    </Layout>
  )
}
export default TagsPage

export const pageQuery = graphql`
  query tagPageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            thumbnail
            tags
          }
        }
      }
    }
  }
`
